import moment from "moment-timezone";
import {useCookies} from "react-cookie";

import {Alert} from "@/components/alert/Alert.tsx";

const COOKIE = "uptime_status_page_update_displayed";

interface Props {
  date: string;
  title: string;
  statusPageURL: string;
}

export const UptimeStatus = ({date, title, statusPageURL}: Props) => {
  const [cookies, setCookie] = useCookies([COOKIE]);
  if (cookies.uptime_status_page_update_displayed) {
    return null;
  }

  return (
    <Alert
      dismissible
      onClear={() => setCookie(COOKIE, 1, {expires: moment().add(1, "days").toDate()})}
      callout={`Uptime.com Status Update (${moment(date).format("MMM-D")})`}
    >
      {title}.
      <a target="_blank" href={statusPageURL}>
        &nbsp;More details
      </a>
    </Alert>
  );
};
